import { supabase } from '@/integrations/supabase/client';
import { getCurrentTenantId } from '@/lib/tenant';
import type { ImpressaoLogData } from '@/types/pdf';

export async function registrarImpressao(
  data: ImpressaoLogData
): Promise<{ success: boolean; error?: string }> {
  try {
    // Buscar informações do usuário atual
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      return { success: false, error: 'Usuário não autenticado' };
    }

    // Buscar tenant_id
    const tenantId = await getCurrentTenantId();

    // Buscar nome do usuário no perfil
    const { data: profile } = await supabase
      .from('profiles')
      .select('full_name')
      .eq('id', user.id)
      .maybeSingle();

    const impressoPorNome = profile?.full_name || user.email || 'Usuário desconhecido';

    // Inserir log
    const { error } = await (supabase as any)
      .from('impressao_log')
      .insert({
        tenant_id: tenantId,
        tipo_documento: data.tipo_documento,
        documento_id: data.documento_id,
        documento_nome: data.documento_nome,
        formato_pagina: data.formato_pagina,
        orientacao: data.orientacao,
        arquivo_tamanho_kb: data.arquivo_tamanho_kb,
        impresso_por_user_id: user.id,
        impresso_por_nome: impressoPorNome,
      });

    if (error) {
      console.error('Erro ao registrar impressão:', error);
      return { success: false, error: error.message };
    }

    return { success: true };
  } catch (err) {
    console.error('Erro inesperado ao registrar impressão:', err);
    return { success: false, error: 'Erro inesperado' };
  }
}

/**
 * Buscar histórico de impressões (para página de relatórios futura)
 */
export async function buscarHistoricoImpressoes(
  filtros?: {
    tipo_documento?: string;
    documento_id?: string;
    data_inicio?: string;
    data_fim?: string;
  }
) {
  let query = (supabase as any)
    .from('impressao_log')
    .select('*')
    .order('impresso_em', { ascending: false });

  if (filtros?.tipo_documento) {
    query = query.eq('tipo_documento', filtros.tipo_documento);
  }

  if (filtros?.documento_id) {
    query = query.eq('documento_id', filtros.documento_id);
  }

  if (filtros?.data_inicio) {
    query = query.gte('impresso_em', filtros.data_inicio);
  }

  if (filtros?.data_fim) {
    query = query.lte('impresso_em', filtros.data_fim);
  }

  return await query;
}
